import {
  Broker,
  CreateBrokerRequest,
  CreateCounterpartyRequest,
  TradingCounterParty
} from "../../api/Api";

// The Edit merger dialog reuses each book's create form, which speaks the create request's field
// names. A few differ from the stored entity's (typeOfTrading / tradingSettlementType, volumeSize
// / dealVolume, mandateGranted / mandate), so these map both ways.

export const counterpartyToRequest = (
  cp: TradingCounterParty
): CreateCounterpartyRequest => ({
  tradingTeam: cp.tradingTeam,
  contactPersonTradingTeam: cp.contactPersonTradingTeam,
  counterpartyName: cp.counterpartyName,
  counterpartyType: cp.counterpartyType,
  counterpartyContactName: cp.counterpartyContactName,
  counterpartyContactEmail: cp.counterpartyContactEmail,
  typeOfTrading: cp.tradingSettlementType,
  productType: cp.productType,
  venue: cp.venue,
  agreementType: cp.agreementType,
  transactionType: cp.transactionType,
  volumeSize: cp.dealVolume,
  unit: cp.unit,
  mandateGranted: cp.mandate,
  urgent: cp.urgent,
  contractingEntity: cp.contractingEntity,
  vp: cp.vp
});

export const applyCounterpartyRequest = (
  cp: TradingCounterParty,
  request: CreateCounterpartyRequest
): TradingCounterParty => ({
  ...cp,
  tradingTeam: request.tradingTeam,
  contactPersonTradingTeam: request.contactPersonTradingTeam,
  counterpartyName: request.counterpartyName,
  counterpartyType: request.counterpartyType,
  counterpartyContactName: request.counterpartyContactName,
  counterpartyContactEmail: request.counterpartyContactEmail,
  tradingSettlementType: request.typeOfTrading,
  productType: request.productType,
  venue: request.venue,
  agreementType: request.agreementType,
  transactionType: request.transactionType,
  dealVolume: request.volumeSize,
  unit: request.unit,
  mandate: request.mandateGranted,
  urgent: request.urgent,
  contractingEntity: request.contractingEntity,
  vp: request.vp ?? null
});

export const brokerToRequest = (broker: Broker): CreateBrokerRequest => ({
  tradingTeam: broker.tradingTeam,
  contactPersonTradingTeam: broker.contactPersonTradingTeam,
  brokerName: broker.brokerName,
  brokerContactName: broker.brokerContactName,
  brokerContactEmail: broker.brokerContactEmail,
  typeOfTrading: broker.tradingSettlementType,
  productType: broker.productType,
  venue: broker.venue,
  agreementType: broker.agreementType,
  transactionType: broker.transactionType,
  volumeSize: broker.dealVolume,
  unit: broker.unit,
  urgent: broker.urgent,
  contractingEntity: broker.contractingEntity,
  vp: broker.vp
});

export const applyBrokerRequest = (
  broker: Broker,
  request: CreateBrokerRequest
): Broker => ({
  ...broker,
  tradingTeam: request.tradingTeam,
  contactPersonTradingTeam: request.contactPersonTradingTeam,
  brokerName: request.brokerName,
  brokerContactName: request.brokerContactName,
  brokerContactEmail: request.brokerContactEmail,
  tradingSettlementType: request.typeOfTrading,
  productType: request.productType,
  venue: request.venue,
  agreementType: request.agreementType,
  transactionType: request.transactionType,
  dealVolume: request.volumeSize,
  unit: request.unit,
  urgent: request.urgent,
  contractingEntity: request.contractingEntity,
  vp: request.vp ?? null
});
